import { render } from "./MyBenefitAllowanceReturn.vue?vue&type=template&id=07e9ada6"
import script from "./MyBenefitAllowanceReturn.vue?vue&type=script&lang=js"
export * from "./MyBenefitAllowanceReturn.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__